import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getActiveUsersByRole = async (
  role,
  organisationID,
  locations = [],
  fromPeople = false,
  page = 1,
  pageSize = 99999,
  isWorkOrder = false
) => {
  const superAdminRole = "super_admin";
  const otherRoles = role.filter((r) => r !== superAdminRole);

  const queryFilters = {
    $and: [
      {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
      },
      {
        blocked: false,
      },

      {
        $or: fromPeople
          ? [
              {
                confirmed: true, // Active users
              },
              {
                confirmed: false, // Pending users
              },
            ]
          : [
              {
                confirmed: true, // Active users only when not fromPeople
              },
            ],
      },
      {
        $or: [
         
       !isWorkOrder ?  {
            role: {
              type: {
                $eq: superAdminRole,
              },
            },
          } : {},
       
          {
            $and: [
              {
                role: {
                  type: {
                    $in: otherRoles,
                  },
                },
              },
              {
                locations: {
                  id: {
                    $in: locations,
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  };

  // Your database querying logic here

  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters: queryFilters,
      "pagination[page]": String(page),
      "pagination[pageSize]": String(pageSize),
      populate: [
        "userProfile",
        "role",
        "locations",
        "teams",
        "supervisor",
        "supervisor.profileImage",
        "createdByUser",
        "createdByUser.profileImage",
        "profileImage",
      ],
    },

    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `users?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error?.message,
    };
  }
};

export const getUserDataDashBoard = async (
  id,
  dashboardFilter,
  assetData = false
) => {
  try {
    let params = {};

    if (assetData == false) {
      params.woDashboardSavedFilter = dashboardFilter;
    } else {
      params.assetDashboardSavedFilter = dashboardFilter;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + `users/${id}`,
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response?.data;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
    };
  }
};

export const getDashboardUsersByID = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "users/" + ID,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response.data;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getUsersByID = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "users/" + ID + "?populate=*&sort[0]=id",
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getAllPeopleByLocation = async (
  customerID,
  organisationID = "",
  page = 1,
  pageSize = 99999
) => {
  const baseFilter = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
  };

  let filters;
  if (customerID?.length === 1) {
    filters = {
      $and: [
        baseFilter,
        {
          $or: [
            {
              role: {
                type: {
                  $eq: "super_admin",
                },
              },
            },

            {
              $and: [
                {
                  role: {
                    type: {
                      $in: ["limited_admin", "admin", "user"],
                    },
                  },
                },
                {
                  locations: {
                    id: {
                      $in: [customerID],
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  } else {
    filters = {
      $and: [
        baseFilter,
        {
          $or: [
            {
              role: {
                type: {
                  $eq: "super_admin",
                },
              },
            },

            {
              $and: [
                {
                  role: {
                    type: {
                      $in: ["limited_admin", "admin", "user"],
                    },
                  },
                },
                {
                  locations: {
                    id: {
                      $in: customerID,
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  }
  const query = qs.stringify(
    {
      sort: ["countNumId:desc"],
      filters,
      "pagination[page]": String(page),
      "pagination[pageSize]": String(pageSize),
      populate: [
        "userProfile",
        "role",
        "locations",
        "teams",
        "supervisor",
        "supervisor.profileImage",
        "createdByUser",
        "createdByUser.profileImage",
        "profileImage",
      ],
    },
    {
      encodeValuesOnly: true,
    }
  );
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `users?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getUserProfileByID = async (ID) => {
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + "user-profiles/" + ID + "?populate=*",
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const getUserData = async (userId = "") => {
  const query = new URLSearchParams({
    populate: [
      "userProfile",
      "role",
      "locations",
      "locations.subLocations",
      "teams",
      "supervisor",
      "supervisor.profileImage",
      "createdByUser",
      "updatedByUser",
      "createdByUser.profileImage",
      "profileImage",
      "organisation",
      "userProfile.job",
      "userProfile.personalPicture",
    ],
  }).toString();

  const subLocationQuery = new URLSearchParams({
    populate: ["location.subLocations"].join(","),
  }).toString();

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `users/${userId}?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return null;
  }
};

export const getUsersByRole = async (
  role,
  organisationID,
  searchName = "",
  page = 1,
  pageSize = 9999,
  role_type = [],
  supervisor = [],
  team = [],
  status = [],
  job = [],
  rate = {},
  sort = [],
  location = [],
  roleData,
  allIds,
  currentUserId
) => {
  const superAdminRole = "super_admin";
  const otherRoles = role.filter((r) => r !== superAdminRole);
  let assetFilters = {
    $and: [
      {
        organisation: {
          id: {
            $eq: organisationID,
          },
        },
      },
      {
        $or: [
          {
            role: {
              type: {
                $eq: superAdminRole,
              },
            },
          },

          {
            $and: [
              {
                role: {
                  type: {
                    $in: otherRoles,
                  },
                },
                // Only add the locations filter based on the condition
                ...(location?.length === 0 && roleData !== "super_admin"
                  ? {
                      locations: {
                        id: {
                          $in: allIds,
                        },
                      },
                    }
                  : {}),
              },
            ],
          },
        ],
      },
    ],
    role: {
      id: {
        $eq: role_type,
      },
    },
    supervisor: {
      id: {
        $in: supervisor,
      },
    },

    teams: {
      id: {
        $in: team,
      },
    },
    userProfile: {
      job: {
        id: {
          $in: job,
        },
      },
    },
  };

  if (status[0] === "true") {
    assetFilters.$and.push({
      confirmed: {
        $eq: true,
      },
      blocked: {
        $eq: false,
      },
    });
  } else if (status[0] === "false") {
    assetFilters.$and.push({
      confirmed: {
        $eq: false,
      },
      blocked: {
        $eq: false,
      },
    });
  } else if (status[0] === "declined") {
    assetFilters.$and.push({
      blocked: {
        $eq: true,
      },
    });
  }

  if (rate.from && !rate.to) {
    assetFilters.userProfile.hourRate = {
      $gte: rate.from,
    };
  } else if (!rate.from && rate.to) {
    assetFilters.userProfile.hourRate = {
      $lte: rate.to,
    };
  } else if (rate.to && rate.from) {
    assetFilters.userProfile.hourRate = {
      $gte: rate.from,
      $lte: rate.to,
    };
  }

 if (roleData === "requester") {
  assetFilters.id = {
    $eq: currentUserId,
  };
} else if (location?.length > 0 || roleData === "super_admin") {
  assetFilters.locations = {
    id: {
      $in: location,
    },
  };
}

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "userProfile",
      "role",
      "locations",
      "teams",
      "supervisor",
      "supervisor.profileImage",
      "createdByUser",
      "updatedByUser",
      "createdByUser.profileImage",
      "profileImage",
      "userProfile.job",
      "userProfile.personalPicture",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `users?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
